const state = {
  report: null,
  config: null,
};

const getters = {
  getReportData: (state) => state.report,
  getPowerBiReportID: (state) => state.config,
};

const actions = {
  async fetchPowerBiApi({ commit }, { rid, uuid }) {
    const response = await this._vm.$http.post("/restapi/oauth/powerbi", {
      rid: rid,
      uuid: uuid,
    });

    commit("setReportData", response.data);
  },

  async getPowerBiConfig({ commit }) {
    const response = await this._vm.$http.get("/restapi/powerbi/config");
    commit("setPowerBiConfig", response.data);
  },
};

const mutations = {
  setReportData: (state, data) => (state.report = data),
  setPowerBiConfig: (state, data) => (state.config = data.config),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
